import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import FormControl from '@material-ui/core/FormControl';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import PSelect from '../GeneralUI/PSelect'
import { SnackbarProvider, withSnackbar } from 'notistack';
import { withRouter } from 'react-router';
import Styles from '../GeneralUI/Styles';
import { errorSetter } from '../../Libs';
import _ from 'lodash';
import Utils from '../../Libs/utils';
import { saveCustom, getDocument, handlerPselect } from '../../Actions/General'
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import Visibility from '@material-ui/icons/Visibility';

class EncuestaBodega extends Component {
  constructor(props) {
    super(props);

    this.setErrors = errorSetter.setErrors.bind(this);
  }

  state = {
    fields: {
      encbodCodigo:null,
      encbodNombre:'ENCUESTA BODEGA',
      clienteNombreCompleto:'',

      encbodObservacion:null,
      encbodCartera:null,
      encbodServicio:null,

      encbodPresentacionBodega:"",
      encbodJefeBodega:"",
      encbodCodificacion:"",
      encbodMercancia:"", 

      createdAt: Utils.fullDateTime(),
      updatedAt: Utils.fullDateTime()
    },
    responseForm: { Message: '', typeMessage: '' },
    urlSave:'/processes/save_encuesta_bodega',
    urlGet:'/processes/get_encuesta_bodega',
    formErrors: {
      encbodServicio: {},
      encbodCartera: {},
    },

    responseForm: { Message: '', typeMessage: '' },

    formValidations: {
      view: ['encbodServicio', 'encbodCartera']
    },

  };

  componentDidMount() {
    // recuperamos el querystring
    const querystring = window.location.search
    const params = new URLSearchParams(querystring)
   
    if (!params.has("Codigo")) {
      return;
    }
  
    this.fillFormData(params.get('Codigo'));   
    this.props.toggleFavorites();
  }


  fillFormData  (id) {

      let document, data; 

      document=saveCustom({codigo:id}, this.state.urlGet);
      if (!id) {
        return;
      }

      this.message("info","SEÑOR USUARIO TODOS LOS CAMPOS SON OBLIGATORIOS");

      document.then(data => {

          if(data===null){
            alert('La pagina no existe, comuniquese con soporte');
            window.close();
          }else{
            this.setState({ fields: data });
          }
          
      }).catch(error => {
          this.message("error","El Registro NO ha sido Guardado." + error.errorMessage);
      });    

  }

  componentWillUnmount() {
    this.props.toogleFavoritesShow();
  }
 
  handleChange = (event) => {
    let { fields } = this.state;
    const caret = event.target.selectionStart;
    const element = event.target;
    if (element.hasOwnProperty('setSelectionRange')) {
      window.requestAnimationFrame(() => {
        element.setSelectionRange(caret, caret);
      });
    }

    if (event.target.type === 'time') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'radio') {
      fields[event.target.name] = event.target.value;
    } else {
      fields[event.target.id] = event.target.value.toUpperCase();
    }

    if (fields[event.target.id] === '') {
      fields[event.target.id] = null;
    }
    this.setState({ fields });
  }

  getSaveFunction() {
      return saveCustom(this.state, this.state.urlSave);
  }

  save = () => {
    if(this.validaData()){
      this.getSaveFunction().then(data => {
        this.message("success","El Registro ha sido Guardado.");
      }).catch(error => {
        this.message("error","El Registro NO ha sido Guardado." + error.errorMessage);
      });        
    }
    
  }

  message = (type, message) => {
    this.props.enqueueSnackbar(message, { variant: type });
  }

  validaData = () => {
    let isvalid = true, message = '', type = "";

    if ((this.state.fields.encbodPresentacionBodega == null || !String(this.state.fields.encbodPresentacionBodega).trim())
    || (this.state.fields.encbodJefeBodega == null || !String(this.state.fields.encbodJefeBodega).trim())
    || (this.state.fields.encbodCodificacion == null || !String(this.state.fields.encbodCodificacion).trim())
    || (this.state.fields.encbodMercancia == null || !String(this.state.fields.encbodMercancia).trim())
    ) {
      message = "DEBE DILIGENCIAR TODAS LAS PREGUNTAS (PREGUNTA 1).";
      type = "error";
      isvalid = false;
    }

    if ((this.state.fields.encbodServicio == null || !String(this.state.fields.encbodServicio).trim())) {
      message = "DEBE DILIGENCIAR TODAS LAS PREGUNTAS (PREGUNTA 2).";
      type = "error";
      isvalid = false;
    }

    if ((this.state.fields.encbodCartera == null || !String(this.state.fields.encbodCartera).trim())) {
      message = "DEBE DILIGENCIAR TODAS LAS PREGUNTAS (PREGUNTA 3).";
      type = "error";
      isvalid = false;
    }
    this.message(type,message);
    return isvalid;
  }

  render() {
    const { classes } = this.props; 
    const userInfo = Utils.getFromLocalStorage('userInfo');

    const nombre = (userInfo?.usuarioNombreCompleto || '')
      .trim()
      .toUpperCase(); 

    const isAllowed = nombre === 'JENNY PAOLA ROCHA' || nombre === 'LUIS NABOR MARINEZ ANGULO' || nombre === 'MARIVEL CECILIA MANJARRES BOTTO';
    return (
      <Paper elevation={5} className={`${classes.mainPaper} ${classes.fullWidthPaper}`}>
        <Grid container spacing={4}>
          <Grid item xs={3} className={classes.gridForm}>
            <img alt='background' src="/bodehogar2.png" width="40%" height="70%" />
          </Grid>
          <Grid item xs className={classes.gridForm}>
            <InputLabel className={classes.tittleLabelForm}>
              ENCUESTA DE SATISFACCION DEL CLIENTE
            </InputLabel>

              <Grid item xs={3} className={this.props.classes.chipTitle}>
              {(this.state.fields.encbodCodigo !== null) ?
                (<Chip
                  label={this.state.fields["encbodCodigo"]}
                  clickable
                  color="primary"
                  onDelete={this.handleSeguir}
                  deleteIcon={<Tooltip title="Seguir" placement="right-start"><Visibility /></Tooltip>}
                />) : ''
              }
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs className={this.props.classes.gridForm}>
            {isAllowed && (
              <InputLabel className={classes.tittleLabelEncuesta}>
                {this.state.fields["encbodInformacionUsuario"]}
              </InputLabel>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid item xs className={this.props.classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                {this.state.fields["clienteNombreCompleto"]}
                </InputLabel>
            </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid item xs className={this.props.classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                1. Durante la prestacion del servicio de almacenamiento:
                </InputLabel>
            </Grid>
        </Grid>              
  
        <Grid container spacing={2}>
            <Grid item xs className={classes.gridForm}>
              <InputLabel className={classes.tittleLabelEncuesta}>
                 a. ¿Cual fue el estado de la mercancia almacenada?
              </InputLabel>
              <FormControl variant="outlined" fullWidth >
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="encbodMercancia"
                    onChange={this.handleChange}
                    value={this.state.fields["encbodMercancia"]}
                  >
                    <FormControlLabel value="1" control={<Radio />} label="1" />
                    <FormControlLabel value="2" control={<Radio />} label="2" />
                    <FormControlLabel value="3" control={<Radio />} label="3" />
                    <FormControlLabel value="4" control={<Radio />} label="4" />
                    <FormControlLabel value="5" control={<Radio />} label="5" />
                  </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs className={classes.gridForm}>      
                <InputLabel className={classes.tittleLabelEncuesta}>
                  b. La codificacion e inventario de lo almacenado.
                </InputLabel>
                <FormControl variant="outlined" fullWidth >
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="encbodCodificacion"
                      onChange={this.handleChange}
                      value={this.state.fields["encbodCodificacion"]}
                    >
                      <FormControlLabel value="1" control={<Radio />} label="1" />
                      <FormControlLabel value="2" control={<Radio />} label="2" />
                      <FormControlLabel value="3" control={<Radio />} label="3" />
                      <FormControlLabel value="4" control={<Radio />} label="4" />
                      <FormControlLabel value="5" control={<Radio />} label="5" />
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs className={classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                    c. Atencion del jefe de bodega.
                </InputLabel>
                <FormControl variant="outlined" fullWidth >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="encbodJefeBodega"
                    onChange={this.handleChange}
                    value={this.state.fields["encbodJefeBodega"]}
                  >
                    <FormControlLabel value="1" control={<Radio />} label="1" />
                    <FormControlLabel value="2" control={<Radio />} label="2" />
                    <FormControlLabel value="3" control={<Radio />} label="3" />
                    <FormControlLabel value="4" control={<Radio />} label="4" />
                    <FormControlLabel value="5" control={<Radio />} label="5" />
                  </RadioGroup>
                </FormControl>
            </Grid>

            <Grid item xs className={classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                    d. Estado y presentacion de la Bodega.
                </InputLabel>
                <FormControl variant="outlined" fullWidth >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="encbodPresentacionBodega"
                    onChange={this.handleChange}
                    value={this.state.fields["encbodPresentacionBodega"]}
                  >
                    <FormControlLabel value="1" control={<Radio />} label="1" />
                    <FormControlLabel value="2" control={<Radio />} label="2" />
                    <FormControlLabel value="3" control={<Radio />} label="3" />
                    <FormControlLabel value="4" control={<Radio />} label="4" />
                    <FormControlLabel value="5" control={<Radio />} label="5" />
                  </RadioGroup>
                </FormControl>
            </Grid>
          </Grid> 

          <Grid container spacing={2}>
            <Grid item xs className={this.props.classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                2. ¿Cual es el motivo por el cual usted utilizo el servicio de Alquiler de Mini Bodega?
                </InputLabel>
                <PSelect
                  id="encbodServicio"
                  useChildren={true}
                  onChange={this.handleChange}
                  namelabel=""
                  value={this.state.fields["encbodServicio"]}
                  formErrors={this.state.formErrors['encbodServicio']}
                >
                  <option value="ESPACIO ADICIONAL">ESPACIO ADICIONAL</option>
                  <option value="COMERCIANTE">COMERCIANTE</option>
                  <option value="ARCHIVO">ARCHIVO</option>
                  <option value="VIAJE">VIAJE</option>
                  <option value="REMODELACION, VENTA Y/O COMPRA DE VIVIENDA">REMODELACION, VENTA Y/O COMPRA DE VIVIENDA</option>
                </PSelect>
            </Grid>
          </Grid>
          <Grid container spacing={2}> 
              <Grid item xs className={this.props.classes.gridForm}>
                  <InputLabel className={classes.tittleLabelEncuesta}>
                  3. ¿Cómo calificas la amabilidad y claridad del area de cartera para resolver tus dudas y necesidades?
                  </InputLabel>
                  <PSelect
                    id="encbodCartera"                    
                    useChildren={true}
                    onChange={this.handleChange}
                    namelabel=""
                    value={this.state.fields["encbodCartera"]}
                    formErrors={this.state.formErrors['encbodCartera']}
                  >
                    <option value="EXCELENTE">EXCELENTE</option>
                    <option value="BUENO">BUENO</option>
                    <option value="REGULAR">REGULAR</option>
                    <option value="MALO">MALO</option>
                  </PSelect>
              </Grid>
          </Grid>

          <Grid container spacing={2}> 

              <Grid item xs className={this.props.classes.gridForm}>
                <InputLabel className={classes.tittleLabelEncuesta}>
                  4. Sugerencias para mejorar nuestros servicios de alquiler de minibodegas.
                </InputLabel>
                <FormControl variant="outlined" fullWidth >
                <TextareaAutosize  id="encbodObservacion"  onChange={this.handleChange} type="text" 
                value={this.state.fields["encbodObservacion"]}                 
                  rows="4"
                  cols="100"
               />
                </FormControl>
            </Grid>
             
          </Grid>

        <Grid container spacing={10} >
          <Grid item xs={3} className={this.props.classes.gridForm}>              
              {(Utils.getFromLocalStorage('userInfo')===null) ?
                (<Button
                  color='primary'
                  variant='contained'
                  onClick={(event) => this.save()}
                >
                Enviar
              </Button>
                ) : ''
              }
          </Grid>
        </Grid>


      </Paper>
    );
  }
}

EncuestaBodega.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
  toggleFavorites: PropTypes.func.isRequired,
  toogleFavoritesShow: PropTypes.func.isRequired
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(EncuestaBodega)));

function IntegrationNotistack(props) {
  return (
    <SnackbarProvider key={6} maxSnack={1}
      action={[
        <Button key={6} variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}
    >
      <MyApp {...props} />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;